"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
function cov_2pzw4eb4uq() {
  var path = "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/ThemeMapper/lib/Evolution.js";
  var hash = "f0fbc257b39e73b5d1500e683a5641160555edf4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/ThemeMapper/lib/Evolution.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 16
        },
        end: {
          line: 3,
          column: 1
        }
      },
      "1": {
        start: {
          line: 5,
          column: 27
        },
        end: {
          line: 5,
          column: 30
        }
      },
      "2": {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 7,
          column: 40
        }
      },
      "3": {
        start: {
          line: 9,
          column: 20
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "4": {
        start: {
          line: 16,
          column: 17
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "5": {
        start: {
          line: 25,
          column: 23
        },
        end: {
          line: 31,
          column: 1
        }
      },
      "6": {
        start: {
          line: 33,
          column: 19
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "7": {
        start: {
          line: 41,
          column: 19
        },
        end: {
          line: 70,
          column: 1
        }
      },
      "8": {
        start: {
          line: 72,
          column: 14
        },
        end: {
          line: 189,
          column: 1
        }
      },
      "9": {
        start: {
          line: 191,
          column: 18
        },
        end: {
          line: 200,
          column: 1
        }
      },
      "10": {
        start: {
          line: 202,
          column: 23
        },
        end: {
          line: 204,
          column: 1
        }
      },
      "11": {
        start: {
          line: 206,
          column: 14
        },
        end: {
          line: 209,
          column: 1
        }
      },
      "12": {
        start: {
          line: 211,
          column: 12
        },
        end: {
          line: 219,
          column: 1
        }
      },
      "13": {
        start: {
          line: 221,
          column: 13
        },
        end: {
          line: 223,
          column: 1
        }
      },
      "14": {
        start: {
          line: 225,
          column: 17
        },
        end: {
          line: 237,
          column: 1
        }
      },
      "15": {
        start: {
          line: 239,
          column: 17
        },
        end: {
          line: 279,
          column: 1
        }
      },
      "16": {
        start: {
          line: 242,
          column: 21
        },
        end: {
          line: 242,
          column: 27
        }
      },
      "17": {
        start: {
          line: 243,
          column: 21
        },
        end: {
          line: 243,
          column: 27
        }
      },
      "18": {
        start: {
          line: 244,
          column: 4
        },
        end: {
          line: 248,
          column: 6
        }
      },
      "19": {
        start: {
          line: 281,
          column: 22
        },
        end: {
          line: 283,
          column: 1
        }
      },
      "20": {
        start: {
          line: 285,
          column: 14
        },
        end: {
          line: 315,
          column: 1
        }
      },
      "21": {
        start: {
          line: 288,
          column: 21
        },
        end: {
          line: 288,
          column: 27
        }
      },
      "22": {
        start: {
          line: 289,
          column: 21
        },
        end: {
          line: 289,
          column: 27
        }
      },
      "23": {
        start: {
          line: 290,
          column: 4
        },
        end: {
          line: 294,
          column: 6
        }
      },
      "24": {
        start: {
          line: 317,
          column: 15
        },
        end: {
          line: 367,
          column: 1
        }
      },
      "25": {
        start: {
          line: 369,
          column: 16
        },
        end: {
          line: 376,
          column: 1
        }
      },
      "26": {
        start: {
          line: 378,
          column: 16
        },
        end: {
          line: 385,
          column: 1
        }
      },
      "27": {
        start: {
          line: 387,
          column: 18
        },
        end: {
          line: 390,
          column: 1
        }
      },
      "28": {
        start: {
          line: 392,
          column: 16
        },
        end: {
          line: 394,
          column: 1
        }
      },
      "29": {
        start: {
          line: 396,
          column: 20
        },
        end: {
          line: 401,
          column: 1
        }
      },
      "30": {
        start: {
          line: 403,
          column: 13
        },
        end: {
          line: 411,
          column: 1
        }
      },
      "31": {
        start: {
          line: 413,
          column: 20
        },
        end: {
          line: 417,
          column: 1
        }
      },
      "32": {
        start: {
          line: 419,
          column: 18
        },
        end: {
          line: 450,
          column: 1
        }
      },
      "33": {
        start: {
          line: 452,
          column: 13
        },
        end: {
          line: 468,
          column: 1
        }
      },
      "34": {
        start: {
          line: 470,
          column: 19
        },
        end: {
          line: 495,
          column: 1
        }
      },
      "35": {
        start: {
          line: 497,
          column: 19
        },
        end: {
          line: 506,
          column: 1
        }
      },
      "36": {
        start: {
          line: 508,
          column: 17
        },
        end: {
          line: 548,
          column: 1
        }
      },
      "37": {
        start: {
          line: 550,
          column: 22
        },
        end: {
          line: 552,
          column: 1
        }
      },
      "38": {
        start: {
          line: 554,
          column: 20
        },
        end: {
          line: 654,
          column: 1
        }
      },
      "39": {
        start: {
          line: 656,
          column: 14
        },
        end: {
          line: 658,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 241,
            column: 6
          },
          end: {
            line: 241,
            column: 7
          }
        },
        loc: {
          start: {
            line: 241,
            column: 12
          },
          end: {
            line: 249,
            column: 3
          }
        },
        line: 241
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 287,
            column: 6
          },
          end: {
            line: 287,
            column: 7
          }
        },
        loc: {
          start: {
            line: 287,
            column: 12
          },
          end: {
            line: 295,
            column: 3
          }
        },
        line: 287
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f0fbc257b39e73b5d1500e683a5641160555edf4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2pzw4eb4uq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2pzw4eb4uq();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cssVars = (cov_2pzw4eb4uq().s[0]++, {
  boxShadowColor: '--box-shadow-color'
});
var advantageBgOpacity = (cov_2pzw4eb4uq().s[1]++, 0.1);
var screens = (cov_2pzw4eb4uq().s[2]++, ['sm', 'md', 'lg', 'xl']);
var breakpoints = (cov_2pzw4eb4uq().s[3]++, {
  sm: 391,
  md: 769,
  lg: 1024,
  xl: 1441
});
var spacings = (cov_2pzw4eb4uq().s[4]++, {
  sm: 0,
  md: 8,
  lg: 16,
  xl: 24,
  xxl: 32,
  xxxl: 48
});
var boxShadowSizes = (cov_2pzw4eb4uq().s[5]++, {
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  xxl: '20px'
});
var fontWeight = (cov_2pzw4eb4uq().s[6]++, {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  xBold: 800
});
var typography = (cov_2pzw4eb4uq().s[7]++, {
  h4: {
    fontSize: '36px',
    lineHeight: '42px'
  },
  h6: {
    fontSize: '24px',
    lineHeight: '32px'
  },
  subHeadline: {
    fontSize: '20px',
    lineHeight: '25px'
  },
  body1: {
    fontSize: '18px',
    lineHeight: '26px'
  },
  body2: {
    fontSize: '16px',
    lineHeight: '24px'
  },
  caption1: {
    fontSize: '14px',
    lineHeight: '20px'
  },
  caption2: {
    fontSize: '12px',
    lineHeight: '16px'
  }
});
var color = (cov_2pzw4eb4uq().s[8]++, {
  textDateTitle: '#3C4045',
  base: {
    white: '#fff',
    black: '#000'
  },
  primary: {
    50: '#F6F6F8',
    100: '#EDEDF1',
    200: '#DCDAE2',
    300: '#CAC8D4',
    400: '#B2AEBF',
    500: '#7A7493',
    600: '#4F4770',
    700: '#3F395A',
    800: '#342F4D',
    900: '#2F2B43'
  },
  info: {
    50: '#F4F7FE',
    100: '#E9EFFD',
    200: '#C8D8FA',
    300: '#92B1F5',
    400: '#5C8AF0',
    500: '#2563EB',
    600: '#1F54C8',
    700: '#1943A0',
    800: '#10327E',
    900: '#0B265F'
  },
  alpha: {
    dark: {
      50: '#F4F4F5',
      100: '#EBEAED',
      200: '#D5D5D9',
      300: '#C1C0C7',
      400: '#ACAAB4',
      500: '#595474',
      600: '#545067',
      700: '#555265',
      800: '#595569',
      900: '#444156'
    },
    black: {
      90: 'rgba(47, 43, 67, 0.9)',
      80: 'rgba(47, 43, 67, 0.8)',
      70: 'rgba(47, 43, 67, 0.7)',
      60: 'rgba(47, 43, 67, 0.6)',
      50: 'rgba(47, 43, 67, 0.5)',
      40: 'rgba(47, 43, 67, 0.4)',
      30: 'rgba(47, 43, 67, 0.3)',
      20: 'rgba(47, 43, 67, 0.2)',
      10: 'rgba(47, 43, 67, 0.1)',
      5: 'rgba(47, 43, 67, 0.05)'
    },
    white: {
      90: 'rgba(255, 255, 255, 0.9)',
      80: 'rgba(255, 255, 255, 0.8)',
      70: 'rgba(255, 255, 255, 0.7)',
      60: 'rgba(255, 255, 255, 0.6)',
      50: 'rgba(255, 255, 255, 0.5)',
      40: 'rgba(255, 255, 255, 0.4)',
      30: 'rgba(255, 255, 255, 0.3)',
      20: 'rgba(255, 255, 255, 0.2)',
      10: 'rgba(255, 255, 255, 0.1)',
      5: 'rgba(255, 255, 255, 0.05)'
    }
  },
  success: {
    50: '#EFFDF6',
    100: '#D9F9E6',
    200: '#B8F1D2',
    300: '#8EE4BA',
    400: '#6AD09D',
    500: '#53B483',
    600: '#2F9461',
    700: '#2F7657',
    800: '#255E46',
    900: '#1E4D3A'
  },
  alert: {
    50: '#FEFAF5',
    100: '#FBF2CB',
    200: '#FBF2CB',
    300: '#FFD16A',
    400: '#FBBC55',
    500: '#E9A23B',
    600: '#C8811A',
    700: '#A35C00',
    800: '#8B4400',
    900: '#78310B'
  },
  destructive: {
    50: '#FEF2F2',
    100: '#FDE9E9',
    200: '#FAC7C7',
    300: '#F7A1A1',
    400: '#F37373',
    500: '#F34141',
    600: '#CD3636',
    700: '#A32E2E',
    800: '#7C2323',
    900: '#7C2323'
  },
  evolution: {
    900: '#212121',
    800: '#342F4D',
    700: '#4A4458',
    600: '#4F4770',
    500: '#7A7493',
    400: '#B2AEBF',
    300: '#B2AEBF',
    200: '#EAEAEC',
    100: '#FBFBFD',
    50: '#FFF'
  },
  focusRing: 'rgba(132, 66, 211, 0.48)'
});
var boxShadow = (cov_2pzw4eb4uq().s[9]++, {
  0: '0px 0px 7px 0px rgba(0, 0, 0, 0.10)',
  1: "0px 0px 3px 0px ".concat(color.alpha.black[10], ", 0px -1px 0px 0px ").concat(color.alpha.black[10]),
  2: "0px -1px 0px 0px ".concat(color.alpha.black[10], ", 0px 4px 8px 0px ").concat(color.alpha.black[10]),
  custom: {
    0: "".concat(color.alpha.black[10], " 0px 2px 4px 0px, ").concat(color.alpha.black[30], " 0px 2px 16px 0px"),
    1: "".concat(color.alpha.black[30], " 0px 1px 2px 0px, ").concat(color.alpha.black[10], " 0px 1px 3px 1px"),
    2: "".concat(color.alpha.black[20], " 0px 10px 20px, ").concat(color.alpha.black[30], " 0px 6px 6px")
  }
});
var boxShadowStyle = (cov_2pzw4eb4uq().s[10]++, {
  0: "0px 0px 0px 3px var(".concat(cssVars.boxShadowColor, ")")
});
var image = (cov_2pzw4eb4uq().s[11]++, {
  interactiveScale: 1.05,
  interactiveTime: '100ms'
});
var box = (cov_2pzw4eb4uq().s[12]++, {
  padding: '20px',
  borderRadius: '20px',
  boxShadow: "rgba(0, 0, 0, 0.08) 0px 4px ".concat(boxShadowSizes.xl),
  focused: {
    boxShadow: "0px 0px 0px 3px ".concat(color.focusRing)
  },
  bg: 'white'
});
var icon = (cov_2pzw4eb4uq().s[13]++, {
  size: '20px'
});
var checkbox = (cov_2pzw4eb4uq().s[14]++, {
  size: '20px',
  border: "1px solid ".concat(color.alpha.black[10]),
  bgColor: 'white',
  color: 'white',
  borderRadius: '4px',
  checked: {
    bgColor: color.info[500]
  },
  icon: {
    size: '12px'
  }
});
var dropdown = (cov_2pzw4eb4uq().s[15]++, _objectSpread(_objectSpread(_objectSpread({}, typography.caption1), function () {
  cov_2pzw4eb4uq().f[0]++;
  var paddingY = (cov_2pzw4eb4uq().s[16]++, '14px');
  var paddingX = (cov_2pzw4eb4uq().s[17]++, '16px');
  cov_2pzw4eb4uq().s[18]++;
  return {
    padding: "".concat(paddingY, " ").concat(paddingX),
    paddingY: paddingY,
    paddingX: paddingX
  };
}()), {}, {
  fontWeight: fontWeight.medium,
  icon: icon,
  color: color.primary[900],
  bgColor: 'white',
  border: "1px solid ".concat(color.alpha.black[20]),
  borderRadius: '12px',
  boxShadow: boxShadow[1],
  hover: {
    border: "1px solid ".concat(color.alpha.black[70])
  },
  focused: {
    boxShadow: "0px 0px 0px 3px ".concat(color.focusRing)
  },
  menu: {
    bgColor: 'white',
    borderRadius: '20px',
    boxShadow: boxShadow[2],
    border: "1px solid ".concat(color.alpha.black[10])
  },
  option: _objectSpread(_objectSpread({}, typography.caption1), {}, {
    fontWeight: fontWeight.medium,
    padding: '10px 16px',
    bgColor: 'white',
    color: color.primary[900],
    hover: {
      bgColor: color.alpha.black[5]
    }
  })
}));
var multiDropdown = (cov_2pzw4eb4uq().s[19]++, _objectSpread({}, dropdown));
var input = (cov_2pzw4eb4uq().s[20]++, _objectSpread(_objectSpread(_objectSpread({}, typography.caption1), function () {
  cov_2pzw4eb4uq().f[1]++;
  var paddingY = (cov_2pzw4eb4uq().s[21]++, '14px');
  var paddingX = (cov_2pzw4eb4uq().s[22]++, '16px');
  cov_2pzw4eb4uq().s[23]++;
  return {
    padding: "".concat(paddingY, " ").concat(paddingX),
    paddingY: paddingY,
    paddingX: paddingX
  };
}()), {}, {
  icon: {
    size: '16px'
  },
  height: '40px',
  padding: "0 ".concat(spacings.lg, "px"),
  color: color.primary[900],
  borderRadius: '12px',
  border: "1px solid ".concat(color.alpha.black[30]),
  boxShadow: "0px 1px 3px 0px ".concat(color.alpha.black[10]),
  boxShadowColor: color.alpha.black[10],
  boxShadowStyle: boxShadowStyle[0],
  boxShadowOpacity: 0.48,
  bgColor: 'white',
  hover: {
    border: "1px solid ".concat(color.alpha.black[70])
  },
  focused: {
    boxShadow: "0px 0px 0px 3px ".concat(color.focusRing)
  }
}));
var button = (cov_2pzw4eb4uq().s[24]++, _objectSpread(_objectSpread({}, typography.caption1), {}, {
  borderRadius: '12px',
  fontWeight: fontWeight.medium,
  height: '40px',
  padding: {
    sm: '6px 12px',
    md: '8px 16px',
    lg: '12px 16px'
  },
  focused: {
    boxShadowStyle: boxShadowStyle[0],
    boxShadowColor: color.alpha.black[10]
  },
  primary: {
    bgColor: color.primary[900],
    color: 'white',
    hover: {
      bgColor: color.primary[700]
    },
    focused: {
      boxShadow: box.focused.boxShadow
    }
  },
  secondary: {
    bgColor: color.alpha.black[5],
    color: 'black',
    hover: {
      bgColor: color.alpha.black[10]
    },
    focused: {
      boxShadow: box.focused.boxShadow
    }
  },
  tertiary: {
    bgColor: 'white',
    color: 'black',
    border: "1px solid ".concat(color.alpha.black[10]),
    hover: {
      bgColor: color.primary[50],
      boxShadow: "0px 1px 3px 0px ".concat(color.alpha.black[10], "}")
    },
    focused: {
      boxShadow: box.focused.boxShadow
    }
  },
  disabled: {
    bgColor: color.primary[50],
    color: color.primary[400]
  }
}));
var section = (cov_2pzw4eb4uq().s[25]++, {
  marginTop: "".concat(spacings.xxxl, "px"),
  padding: box.padding,
  borderRadius: box.borderRadius,
  bg: box.bg,
  boxShadow: 'rgba(0, 0, 0, 0.08) 0px 4px 12px',
  maxWidth: "".concat(breakpoints.xl, "px")
});
var catalog = (cov_2pzw4eb4uq().s[26]++, {
  marginX: "".concat(spacings.md, "px"),
  marginTop: "".concat(spacings.xl, "px"),
  padding: "".concat(spacings.xxl, "px"),
  borderRadius: box.borderRadius,
  bg: box.bg,
  boxShadow: "rgba(0, 0, 0, 0.08) 0px 4px ".concat(boxShadowSizes.lg)
});
var filmStrip = (cov_2pzw4eb4uq().s[27]++, {
  catalog: catalog,
  slidingVisibleSize: "".concat(spacings.xxxl, "px")
});
var product = (cov_2pzw4eb4uq().s[28]++, {
  color: 'black'
});
var productList = (cov_2pzw4eb4uq().s[29]++, {
  padding: "".concat(spacings.xl, "px"),
  margin: "".concat(spacings.lg, "px 0"),
  boxShadow: box.boxShadow,
  borderRadius: box.borderRadius
});
var card = (cov_2pzw4eb4uq().s[30]++, {
  padding: '12px',
  image: {
    borderRadius: '12px'
  },
  borderRadius: box.borderRadius,
  boxShadow: "0px 4px ".concat(boxShadowSizes.xxl, " 0px rgba(0, 0, 0, 0.1)"),
  bgColor: 'white'
});
var productLine = (cov_2pzw4eb4uq().s[31]++, _objectSpread(_objectSpread({}, card), {}, {
  padding: '16px 20px',
  boxShadow: "0px 0px ".concat(boxShadowSizes.xl, " 0px rgba(73, 73, 73, 0.10)")
}));
var filterBar = (cov_2pzw4eb4uq().s[32]++, {
  gap: "14px",
  cols: 1,
  sm: {
    cols: 2
  },
  md: {
    cols: 5,
    gap: "14px 12px"
  },
  padding: "".concat(spacings.xl, "px"),
  bgColor: 'white',
  boxShadow: box.boxShadow,
  borderRadius: box.borderRadius,
  color: color.primary[900],
  filterButton: {
    label: _objectSpread(_objectSpread({}, typography.caption1), {}, {
      fontWeight: fontWeight.medium,
      color: color.primary[900]
    }),
    multiDropdown: multiDropdown,
    input: _objectSpread(_objectSpread({}, input), {}, {
      icon: _objectSpread(_objectSpread({}, icon), {}, {
        color: color.alpha.black[60]
      })
    })
  },
  icon: icon
});
var tabs = (cov_2pzw4eb4uq().s[33]++, {
  borderColor: color.alpha.black[10],
  borderSize: '1px',
  items: _objectSpread(_objectSpread({}, typography.body2), {}, {
    fontWeight: fontWeight.medium,
    padding: "".concat(spacings.xl / 2, "px ").concat(spacings.xl, "px"),
    button: {
      padding: "12px 16px"
    },
    color: color.alpha.black[60],
    active: {
      color: color.primary[900],
      borderSize: '2px'
    }
  })
});
var priceRange = (cov_2pzw4eb4uq().s[34]++, {
  bullet: {
    size: '16px',
    borderRadius: '50%',
    bgColor: color.info[500],
    borderWidth: '4px',
    borderStyle: 'solid',
    borderColor: 'white',
    pressed: {
      boxShadow: "0px 0px 4px ".concat(color.info[200]),
      outline: "4px solid ".concat(color.info[200])
    }
  },
  price: _objectSpread(_objectSpread({}, typography.caption1), {}, {
    fontWeight: fontWeight.medium,
    color: color.primary[900]
  }),
  slider: {
    bgColor: color.primary[100],
    fillColor: color.info[500],
    borderRadius: '5px',
    border: "3px solid ".concat(color.primary[100]),
    size: '10px'
  }
});
var ticketShop = (cov_2pzw4eb4uq().s[35]++, {
  viewSelector: {
    gap: '10px',
    button: {
      padding: "".concat(spacings.lg, "px"),
      borderRadius: '50%',
      size: '48px'
    }
  }
});
var calendar = (cov_2pzw4eb4uq().s[36]++, {
  wrapper: {
    border: '1px solid #e8e8e8',
    color: '#969696',
    borderRadius: '8px',
    bgColor: 'white'
  },
  day: {
    color: '#000000',
    disabled: {
      color: '#969696'
    },
    selected: {
      bgColor: '#F4F5FF'
    },
    padding: '12px'
  },
  productSticker: {
    border: '1px solid #2F2B431A;',
    bgColor: 'white',
    padding: '2px 8px',
    borderRadius: box.borderRadius
  },
  miniCalendar: {
    width: '350px',
    monthSelector: {
      padding: '0 10px',
      height: '32px',
      color: color.primary[900]
    },
    weekday: _objectSpread(_objectSpread({}, typography.body2), {}, {
      fontWeight: fontWeight.bold,
      color: color.textDateTitle,
      display: 'flex',
      padding: '10px',
      justifyContent: 'center',
      alignItems: 'center'
    })
  }
});
var advantageCode = (cov_2pzw4eb4uq().s[37]++, {
  bgColor: 'white'
});
var hospitality = (cov_2pzw4eb4uq().s[38]++, {
  tabs: {
    bgColor: 'white',
    color: color.primary[900],
    active: {
      bgColor: color.info[50],
      markerColor: color.info[500]
    },
    boxShadow: "0px 0px 3px 0px ".concat(color.alpha.black[10], ", 0px -1px 0px 0px ").concat(color.alpha.black[10])
  },
  icon: icon,
  buttons: _objectSpread(_objectSpread({}, typography.caption1), {}, {
    fontWeight: fontWeight.medium,
    color: color.primary[900],
    padding: '14px 16px'
  }),
  productLine: {
    package: {
      buttons: _objectSpread(_objectSpread({}, typography.caption2), {}, {
        fontWeight: fontWeight.semibold,
        cols: 7,
        GOOD: {
          color: color.success[700],
          bgColor: color.success[50]
        },
        LIMITED: {
          color: color.alert[700],
          bgColor: color.alert[50]
        },
        NONE: {
          color: color.destructive[700],
          bgColor: color.destructive[50]
        },
        padding: '10px',
        borderRadius: '6px',
        gap: '12px',
        md: {
          cols: 2
        },
        lg: {
          cols: 4
        },
        xl: {
          cols: 5
        }
      })
    },
    tooltip: {
      borderRadius: '12px',
      bgColor: 'white',
      boxShadow: boxShadow.custom[0],
      padding: '14px 16px'
    },
    borderRadius: '20px',
    boxShadow: boxShadow[0],
    image: {
      height: '159px',
      width: '240px',
      gapX: "".concat(spacings.xl, "px")
    },
    title: _objectSpread(_objectSpread({}, typography.body2), {}, {
      fontWeight: fontWeight.bold
    }),
    availabilityBadge: _objectSpread(_objectSpread({}, typography.caption1), {}, {
      fontWeight: fontWeight.medium,
      border: "1px solid ".concat(color.alpha.black[10]),
      borderRadius: '20px',
      padding: "0 ".concat(spacings.md, "px"),
      gap: '4px',
      icon: {
        size: '8px'
      },
      GOOD: {
        color: "var(--availabilityGoodColor, ".concat(color.success[500], ")"),
        bgColor: "var(--availabilityGoodBgColor, rgba(51,157,51,0.05))"
      },
      LIMITED: {
        color: "var(--availabilityLimitedColor, ".concat(color.alert[500], ")"),
        bgColor: "var(--availabilityLimitedBgColor, rgba(237,134,52,0.05))"
      },
      NONE: {
        color: "var(--availabilityNoneColor, ".concat(color.destructive[500], ")"),
        bgColor: "var(--availabilityNoneBgColor, rgba(216,28,56,0.05))"
      }
    }),
    content: _objectSpread(_objectSpread({}, typography.caption1), {}, {
      fontWeight: fontWeight.normal,
      bgColor: 'white',
      padding: "".concat(spacings.lg, "px"),
      gap: '12px',
      color: 'black'
    })
  }
});
var popup = (cov_2pzw4eb4uq().s[39]++, {
  minWidth: '342px'
});
var _default = exports.default = {
  fontWeight: fontWeight,
  typography: typography,
  color: color,
  box: box,
  button: button,
  catalog: catalog,
  card: card,
  priceRange: priceRange,
  breakpoints: breakpoints,
  spacings: spacings,
  screens: screens,
  input: input,
  tabs: tabs,
  boxShadowSizes: boxShadowSizes,
  product: product,
  productList: productList,
  section: section,
  ticketShop: ticketShop,
  filterBar: filterBar,
  calendar: calendar,
  advantageCode: advantageCode,
  productLine: productLine,
  filmStrip: filmStrip,
  hospitality: hospitality,
  icon: icon,
  multiDropdown: multiDropdown,
  boxShadow: boxShadow,
  checkbox: checkbox,
  dropdown: dropdown,
  boxShadowStyle: boxShadowStyle,
  cssVars: cssVars,
  advantageBgOpacity: advantageBgOpacity,
  image: image,
  popup: popup
};